import React from 'react';

interface ArtistSpotlightProps {
    label?: string;
    artist: {
        name: string;
        handle: string;
        avatar: string;
        bio: string;
    };
    featuredWork: {
        image: string;
        title: string;
    };
    ctaLabel?: string;
    ctaLink: string;
    className?: string;
}

export const ArtistSpotlight: React.FC<ArtistSpotlightProps> = ({
    label = 'Currently vibing to...',
    artist,
    featuredWork,
    ctaLabel = 'View their work',
    ctaLink,
    className = '',
}) => {
    return (
        <div className={`curator-spotlight ${className}`}>
            <div className="curator-spotlight-info">
                <div className="curator-spotlight-label">{label}</div>

                <div className="curator-spotlight-artist">
                    <img
                        src={artist.avatar}
                        alt={artist.name}
                        className="curator-spotlight-avatar"
                    />
                    <div>
                        <div className="curator-spotlight-name">{artist.name}</div>
                        <div className="curator-spotlight-handle">{artist.handle}</div>
                    </div>
                </div>

                <p className="curator-spotlight-bio">{artist.bio}</p>

                <a
                    href={ctaLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="curator-spotlight-cta"
                >
                    {ctaLabel} <span>→</span>
                </a>
            </div>

            <div className="curator-spotlight-work">
                <img src={featuredWork.image} alt={featuredWork.title} />
            </div>
        </div>
    );
};

export default ArtistSpotlight;
